import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header";
import Home from "./components/Home";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import About from "./pages/About";
import Missionsection from "./pages/Missionsection";

import Photos from "./pages/Photos";
import Event from "./pages/Event";

import EducationPages from "./pages/EducationPage";
import SportsPage from "./pages/SportsPage";
import HospitalityPage from "./pages/HospitalityPage";
import MediaPage from "./pages/MediaPage";
import HealthcarePage from "./pages/HealthcarePage";
import Newsclippings from "./pages/Newsclippings";

import Contact from "./pages/Contact";


function NotFound() {
  return <h4 className="text-center mt-4">Page does not exist</h4>;
}

function Layout() {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      {location.pathname !== "/" && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/about" element={<About />} />
        <Route path="/mission-vision" element={<Missionsection />} />

        <Route path="/gallery" element={<Photos />} />
        <Route path="/event" element={<Event />} />

        <Route path="/education" element={<EducationPages />} />
        <Route path="/sports" element={<SportsPage />} />
        <Route path="/hospitality" element={<HospitalityPage />} />
        <Route path="/media" element={<MediaPage />} />
        <Route path="/healthcare" element={<HealthcarePage />} />
        <Route path="/newsclippings" element={<Newsclippings />} />

        <Route path="/contact" element={<Contact />} />

        <Route path="*" element={<NotFound />} />
      </Routes>

      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
    
  );
}

export default App;